import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class DiscardCriterionService {
    constructor(private http: HttpClient) {}
    getConfigValidatorList(): Observable<any> {
        return this.http.get(environment.api_url + `/config/validator/discard_criterion/list`);
    }
    updateConfigValidator(validator): Observable<any> {
        return this.http.post(
            environment.api_url + `/config/validator/discard_criterion/${validator.id}/edit`,
            validator
        );
    }
}
